export class CompanyBrand {
    public cod: string;
    public companyName: string;
  }
  
  export const CompanyList: CompanyBrand[] = [
    {
      cod: 'f00c37cc-accf-48c7-8c21-50b63f32d1c1',
      companyName: 'mapfre'
    },
    {
      cod: '79c206c7-021c-489f-8fd1-6f985faa1343',
      companyName: 'bb_seguros'
    },
    {
      cod: '29a138a1-a9e7-45f6-9b55-9f62f6e0972f',
      companyName: 'tokio'
    },
    {
      cod: 'de6f95d9-7c82-4f61-a2c9-670246e9962c',
      companyName: 'suhai'
    },
    {
      cod: 'ae4b90e8-69fe-4c7d-91e0-5cbb6c1a2695',
      companyName: 'rodobens'
    },
    {
      cod: '229a8f96-2d04-41c7-b498-ae8698690066',
      companyName: 'sura'
    },
    {
      cod: '6f52dece-cfc4-4bfc-a6cd-7e697584001a',
      companyName: 'allianz'
    },
    {
      cod: 'c1db8823-6960-4555-a354-eee9c31404a5',
      companyName: 'youse'
    },
    {
      cod: '0203d8b3-2121-47ac-8625-d13e0b1a52a1',
      companyName: 'banco_pan'
    },
    {
      cod: '2a581b6b-d6b0-4d84-af2a-c37c5527f25a',
      companyName: 'planetun'
    }
  ]
  